module.exports = __webpack_public_path__ + "img/108.4d09e886.svg";